// Flag product cards that show a "Sold out" badge
(function () {
  function flag() {
    document.querySelectorAll('.card').forEach((card) => {
      if (card.classList.contains('is-sold-out')) return;
      const badge = card.querySelector('.badge, .card__badge, [class*="badge"]');
      if (badge && /sold\s*out|unavailable/i.test(badge.textContent || '')) {
        card.classList.add('is-sold-out');
      }
    });
  }

  // Run now
  document.addEventListener('DOMContentLoaded', flag);

  // Run again when sections lazy-load / paginate
  const mo = new MutationObserver(flag);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();